const MAX_ROUTE_AMOUNT = 4;

export const multiCityFormConfig = {
  MAX_ROUTE_AMOUNT,
};
